import Reports from '@/api/reportService';
import router from '@/router/index'
// import store from '@/store';
const state = {
 linkList:[],
 urlJson:{},
 reportServiceChannelKey:null,
 gridInfoData:{
    "columns": [
        {
            "field": "ProductID",
            "title": "Id",
            "dataType": "number"
        },
        {
            "field": "ProductName",
            "title": "Name",
            "dataType": "string",
            "sort": "asc"
        },
        {
            "field": "UnitPrice",
            "title": "Price",
            "dataType": "number"
        }
    ],
    "columnOrder": [],
    "dataSource": {
        "url": "products.json",
        "method": "GET"
    },
    "sortable": true,
    "pageable": {
        "pageSizes": true,
        "server": true,
        "skip": 0,
        "take": 5
    }
},
//    linkList:[	"MIS Report – Ground Audit"	,
//    "MIS Report – Ananyajtac MIS – Looks same as Ground Audit.",	
//    "MIS Report – KM Wise Billing"	,
//    "MIS Report – Trip wise Billing	",
//    "MIS Report – Slab wise Billing"	,
//    "MIS Report – Vendor wise Billing"	,
//    "MIS Report – Trip wise Billing ERN"	,
//    "MIS Report – Vendor Slab wise Billing"	,
//    "MIS Report – Vendor wise Billing Trip",
//    "MIS Report – Employee per head report	",
//    "Vendor Scheduled vs Actual		Vehicle Out Time Report",
//    "History Scheduled vs Actual	",
//    "Driver App Trip sheet Status"	,
//        "Employee Trip Report"	,
//    "Log Report – Vehicle Change Log	",
//    "Log Report – Manual Trip Close Log",	
//    "Log Report – Special Rate Change Log",
//    "Log Report – Slab wise Pricing Log"	,
//    "Log Report – Employee Logs"	,
//    "ERN Report – Vehicle wise trip sheet ERN Report",
//    "ERN Report – Show ERN Report"	,
//    "ERN Report – No Show ERN Report	",
//    "ERN Report – ERN vs Geofence"	,
//    "Employee Pick up details"	,
//    "Employee Boarding Report"	,
//    "OTA OTD Summary Report",	
//    "Employee Trip Report ",
//    "MiS Kilometer wise (ERN)"	,
//    "Miscellaneous Reports – SMS log report",	
//    "Miscellaneous Reports – Employee ETA SMS Report",
//    "Miscellaneous Reports – ERN Consolidated Report",
//    "Miscellaneous Reports – Cab Waited Log",	"Miscellaneous Reports – Escort Change Log",
//    "Miscellaneous Reports – Driver Feedback",	
//    "Miscellaneous Reports – Consolidated ERN No Show"	,
//    "Miscellaneous Reports – Actual No show Log"	,
//    "Miscellaneous Reports – Mail Log Report",
// "	Miscellaneous Reports – Employee Show/No Show"	,
//    "Miscellaneous Reports – Escort Log",	
//    "Miscellaneous Reports – Sms Delivery Log",
//    "Miscellaneous Reports – Security Verified Log	",
// "	Miscellaneous Reports – Voice Call Log",	
//    "Miscellaneous Reports – Voice Call Report"	,
//    "Miscellaneous Reports – Vehicle Change log report"	,
//    "Miscellaneous Reports – SMS Credits Report"	,
//    "Miscellaneous Reports – SIM Change Log",
//    "Miscellaneous Reports – SMS Credit Reminder	Roster Vs Tripsheet",
//    "Intelligent Reports- Time Sheet Report",
//    "Reports (All Vehicle) - Consolidated No Show Report"	,
//    "Reports (All Vehicle) - Consolidated Show Report",	
//    "Reports (Single Vehicle) - Employee Login/Logout Report",
//    "Reports (Single Vehicle) - Employee No Show Report",	
//    "Reports (Single Vehicle) - Employee Show Report"],
baseUrl:null,
rawLinkList:[],
summaryReport: null
}
const getters = {

};

const actions = {
async loadReports({ commit }) {
    // if (!rootState.selectedFacility) {
    //         return // TODO facility data not loaded
    //     }
      let res =await Reports.getDynamicReport()
    commit('setReports',res.data.reportGroupList)
    commit('getBaseUrl',res.data.reportBaseUrl)
    commit('setRawLinkList', res.data.reportGroupList[0].reports)

    console.log("#setRepo",res.data.reportGroupList[0].reports)
  },

  async getReportJSon({ commit,rootState,state },e) {
       state.reportServiceChannelKey = rootState.reportServiceChannelKey
       e.data.configuration = JSON.parse(e.data.configuration)
       if(e.data.configuration.isSummeryReportExist){
        const summaryReport = state.rawLinkList.find(j=> {
            return e.data.id === j.parentReportID
        });
        if(summaryReport){
            console.log("#linklist",state.linkList);
            console.log("#summaryRepo",JSON.parse(summaryReport.configuration));
            summaryReport.configuration = JSON.parse(summaryReport.configuration)
            commit('setSummaryReport',summaryReport.configuration)
    
        } else {
            commit('setSummaryReport',[])
        }
       }

       console.log("configuration---->",e.data.configuration)
    //    console.log(e)
    //    state.baseUrl = store.state.settings.apiUrl+'/';
    //   let url =state.baseUrl+`report/Report/GetReportJson?ReportID=${e.data.id}`
    //   let payLoad = {
    //       url:url,name:e.data.name
    //   }
    //  let res =await Reports.getReportDetails(e.data.id)
    //   }
    // e.data.dataSource.url = 
    commit('setReportUrl',e.data)
},
async search({ commit, }, word) {
    // let id = rootState.selectedFacility ? rootState.selectedFacility.id : 0
    const res =await Reports.getReports()
    if(word)
   { let val = res.data
        // Return a modified copy of engagements..
        .map((i) => {
            // ..with all answered questions filtered out..
            i.reports = i.reports.filter((x) => x.name.toLowerCase() ===word.toLowerCase());
            return i;
        })
        // ..and only return engagements that have (unanswered) questions left
        .filter((i) => i.reports.length !== 0);
    commit('setReports',val)}
    else{
        commit('setReports',res.data)
    }
    // commit('getEmployee', list)
},
}
const mutations = {
   setReports(state,data){
      state.linkList = data[0].reports
      console.log("link List",data[0].reports)
   },
   setReportUrl(state,data){
      
     state.gridInfoData =data
     router.push({name:"report-details"});
   },
   getBaseUrl(state,urlJson){
       state.urlJson = JSON.parse(urlJson)
       console.log(state.urlJson)
   },
   setSummaryReport(state,data){
        state.summaryReport=data;
   },
   setRawLinkList(state,data){
       console.log("##setting", data);
       state.rawLinkList=data;
   }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}